module.exports = __webpack_public_path__ + "img/s3.954750a9.png";